import { purify } from "../../_src/components/purify";

export default function escolhaCadeiaProdutiva(data) {
  const DOM = {
    target: document.getElementById("cadeias-produtivas"),
    form: document.getElementById("form-cadeia-produtiva"),
    formInput: document.querySelector("#cadeias-produtivas"),
  }

  function replaceUrls(data) {
    DOM.target.querySelectorAll(".btn").forEach(btn => {
      btn.href = "/" + data.url + "/" + btn.dataset.slug;
    });
  }

  function search() {
    DOM.form.querySelector(".btn.rounded--xl").classList.add("loading");

    fetch(`/modal/ajax/cadeia-de-producao`, {
      method: "POST",
      body: new FormData(DOM.form)
    }).then((response) => {
      return response.text();
    }).then((response) => {
      DOM.target.innerHTML = purify(response);
      replaceUrls(data);
    })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        DOM.form.querySelector(".btn.rounded--xl").classList.remove("loading");
      })
  }

  DOM.form.addEventListener("submit", function (e) {
    e.preventDefault();
    search();
  })

  return replaceUrls(data);
}
